import { useEffect, useMemo } from 'react'
import {
  initialQueryState,
  OptionsHelper,
  useDebounce,
} from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  CustomSelect,
  IOption,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaProfissionalListSearchComponent = () => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const { t } = useT()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(
    () =>
      [
        debouncedFilters.ano ? `mesAno.ano:${debouncedFilters.ano.value}` : '',
        debouncedFilters.mes ? `mesAno.mes:${debouncedFilters.mes.value}` : '',
        debouncedFilters.empresa ? `empresa.id:${debouncedFilters.empresa.value}` : '',
      ]
        .filter(Boolean)
        .join(','),
    [debouncedFilters]
  )

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  // Chips da faixa "Filtros ativos": cada × limpa só o seu campo.
  const activeFilters: ActiveFilter[] = [
    filters.empresa && {
      key: 'empresa',
      label: t('empresa.label'),
      value: filters.empresa.label,
      onRemove: () => setFilter('empresa', undefined),
    },
    filters.mes && {
      key: 'mes',
      label: t('mes.label'),
      value: filters.mes.label,
      onRemove: () => setFilter('mes', undefined),
    },
    filters.ano && {
      key: 'ano',
      label: t('ano.label'),
      value: filters.ano.label,
      onRemove: () => setFilter('ano', undefined),
    },
  ].filter((filter): filter is ActiveFilter => Boolean(filter))

  return (
    <TableFilters
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'fatura encontrada' : 'faturas encontradas'}`
          }
        />
      }
    >
      <TableFilter label={t('empresa.label')} wide>
        <CustomSelect
          entity='empresa'
          onChange={(empresa?: IOption<number>) => setFilter('empresa', empresa ?? undefined)}
          fetchOptions={OptionsHelper.getOptionsEmpresas}
          value={filters.empresa}
        />
      </TableFilter>
      <TableFilter label={t('mes.label')}>
        <CustomSelect
          entity='mes'
          onChange={(mes?: IOption<string>) => setFilter('mes', mes ?? undefined)}
          fetchOptions={OptionsHelper.getOptionsMeses}
          value={filters.mes}
        />
      </TableFilter>
      <TableFilter label={t('ano.label')}>
        <CustomSelect
          entity='ano'
          onChange={(ano?: IOption<number>) => setFilter('ano', ano ?? undefined)}
          fetchOptions={OptionsHelper.getOptionsAnos}
          value={filters.ano}
        />
      </TableFilter>
    </TableFilters>
  )
}
